import { writable, get } from 'svelte/store';


const maxHistory = 10;

const { subscribe, set, update } = writable({
	history: [],
});


export const store = {
	subscribe,
	
	/* pushRoute */
  	pushRoute: value => update(self => {
		self.history.unshift(value);
		self.history = self.history.slice(0, maxHistory);
		return self;
	}),

	/* getRoute */
	getRoute: id => get(store).history[id ? id : 0],
};
